import '@vidstack/react/player/styles/base.css';
import '@vidstack/react/player/styles/default/theme.css';
import { EmptyState } from 'module/ui/components/atoms/empty-state';
import { faVideo } from '@fortawesome/pro-regular-svg-icons';
import { Icon, Loader } from '@rocketlane/ui';
import { useMeetingTranscriptQuery } from 'queries/meeting';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { apiTranscriptToUiTranscript } from './api-transcript-ui-transcript';
import { VideoPlayer } from './player/player';
import { useGetMeetingRecordingWithRetry } from './recording-with-retry';
import { SpeakersTimeline } from './speaker-timeline';

type MeetingTranscriptVideoAsSidePaneProps = {
  meetingId: number;
};
export const MeetingTranscriptVideoAsSidePane = ({
  meetingId,
}: MeetingTranscriptVideoAsSidePaneProps) => {
  const {
    meetingRecording,
    isMeetingRecordingLoading,
    refetchMeetingRecordingWithRetry,
  } = useGetMeetingRecordingWithRetry({
    meetingId,
  });
  const { data: meetingTranscript } = useMeetingTranscriptQuery(meetingId);
  const uiTranscript = useMemo(() => {
    if (meetingTranscript && !isMeetingRecordingLoading) {
      return apiTranscriptToUiTranscript(meetingTranscript);
    }

    return undefined;
  }, [meetingTranscript, isMeetingRecordingLoading]);

  return (
    <div className="p-06 flex flex-col gap-03 overflow-hidden h-full">
      {isMeetingRecordingLoading ? (
        <div className="flex justify-center items-center h-full w-full">
          <Loader size={24} />
        </div>
      ) : (
        <div className="flex-1">
          {meetingRecording?.videoUrl != null ? (
            <VideoPlayer
              videoSrc={meetingRecording.videoUrl}
              transcript={uiTranscript}
              onError={refetchMeetingRecordingWithRetry}
            />
          ) : (
            <div className="flex justify-center items-center h-full aspect-video">
              <EmptyState
                image={<Icon icon={faVideo} size={'2x'} />}
                message={
                  <FormattedMessage id="account.meeting_transcript.video.not_available" />
                }
              />
            </div>
          )}
        </div>
      )}
      {uiTranscript && (
        <div className="flex flex-col overflow-y-auto h-full">
          <SpeakersTimeline transcript={uiTranscript} />
        </div>
      )}
    </div>
  );
};
